import {Helmet} from "react-helmet";
import Header from "../Navigation/Header";
import HomePageBanner from "./HomePageBanner";
import Footer from "../Navigation/Footer";
import WaterMoisture  from "./WaterMoisture";
import Irrigation  from "./Irrigation";
import EnergyUsage from "./EnergyUsage";
import NutrientUsage from "./NutrientUsage";
import Metrics from "./Metrics";

function HomePage() {
  	return (
	    <div className="container-fluid">
	      <Helmet>
	        <meta charset="utf-8" />
	        <title>Customer</title>
	        <meta http-equiv='cache-control' content='no-cache'/>
	        <meta http-equiv='expires' content='0'/>
	        <meta http-equiv='pragma' content='no-cache'/>
	      </Helmet>
	      <Header />
	      <HomePageBanner />
	      <WaterMoisture />
	      <Irrigation />
	      <EnergyUsage />
	      <NutrientUsage />
	      <Metrics />
	      <div className="footer_container">
	      <Footer />
	      </div>
	    </div>
  );
}
export default HomePage;
